import { find } from 'lodash';
import {
  GET_GLOBAL_NOTIFICATIONS,
  GET_GLOBAL_NOTIFICATIONS_FAILED,
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_FAILED,
  RECEIVE_GLOBAL_NOTIFICATIONS,
  RECEIVE_NOTIFICATIONS,
  REQUEST_DISMISS_NOTIFICATIONS,
  REQUEST_DISMISS_NOTIFICATIONS_FAILED,
} from './actions';
import { notificationIdentity } from '../../definitions/NotificationConstants';

const initialState = {
  data: [],
  isFetching: true,
  errors: null,
};

// notification shape:
// key - key of notification,
// isFetching - single notification is updating
//
const toNotificationShape = (data) => {
  return data.map((item) => {
    return {
      ...item,
      isFetching: false,
    };
  });
};

const dismissNoti = (notifications, data) => {
  let keys = notifications.map((item) => item[notificationIdentity]);
  return data.map((item) => {
    if (find(keys, (key) => key === item[notificationIdentity])) {
      return {
        ...item,
        isFetching: true,
      };
    }
    return item;
  });
};

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case RECEIVE_NOTIFICATIONS: {
      return {
        ...state,
        isFetching: false,
        data: toNotificationShape(action.data),
      };
    }
    case GET_NOTIFICATIONS_FAILED: {
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    }
    case REQUEST_DISMISS_NOTIFICATIONS: {
      return {
        ...state,
        data: dismissNoti(action.notifications, state.data),
      };
    }
    case REQUEST_DISMISS_NOTIFICATIONS_FAILED: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};

const globalNotifications = (state = initialState, action) => {
  switch (action.type) {
    case GET_GLOBAL_NOTIFICATIONS: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case RECEIVE_GLOBAL_NOTIFICATIONS: {
      return {
        ...state,
        isFetching: false,
        data: action.data,
      };
    }
    case GET_GLOBAL_NOTIFICATIONS_FAILED: {
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    }
    default:
      return state;
  }
};

export { notifications, globalNotifications };
